<template>
  <div class="calendar_tab">
    <div class="header">

      <div class="col left">

        <div class="pagination">
          <span class="prev" @click="prev()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M14 7L10 12L14 17" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          </span>
          <span class="next" @click="next()">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M10 17L14 12L10 7" stroke="#656565" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
          </span>
        </div>

        <span class="today" @click="today()">Сегодня</span>

      </div>

      <div class="col mid">
        <span class="month">{{calendarData.month_string}}</span>
      </div>

      <div class="col right">
        <div class="type" v-if="false">
          <span class="m active">Месяц</span>
          <span class="w">Неделя</span>
          <span class="d">День</span>
        </div>
      </div>

    </div>



    <div class="body">
      <div class="col week_days"><span>пн</span></div>
      <div class="col week_days"><span>вт</span></div>
      <div class="col week_days"><span>ср</span></div>
      <div class="col week_days"><span>чт</span></div>
      <div class="col week_days"><span>пт</span></div>
      <div class="col week_days"><span>сб</span></div>
      <div class="col week_days"><span>вс</span></div>
      <div class="col week_days" v-for="item in this.calendarData.items" :key="item"
           :class="[{v: item.week > 5}]">
        <span class="day"
              :class="[{lm: item.last_month}, {c: item.current_day}]"
        >{{item.number}}</span>
        <div class="event_list">
          <div class="item" :class="event.type" v-for="event in item.event_list" :key="event">
            <div class="time">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
                <circle cx="9" cy="9" r="7.5" stroke="#222222" stroke-width="1.2"/>
                <path d="M7.125 7.125L9.74991 9.74973M12 6L8.25 9.75" stroke="#222222" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>{{event.time}}</span>
            </div>
            <p class="text">
              {{event.text}}
            </p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import axios from "axios";

export default {
  name: 'CalendarTab',
  components: {

  },
  data() {
    return{
      calendarData: {
        month_string: "",
      }
    }
  },
  mounted() {
    this.loadData();
  },
  methods : {
    loadData : async function() {
      let month = this.$route.query.month;

      let res = await axios.get(
          window.api_url + "main/calendar"
          + "&month=" + month
      );

      this.calendarData = res.data.data;
    },
    next : function() {
      this.$router.push({query: {month : this.calendarData.next_month}});
    },
    prev : function() {
      this.$router.push({query: {month : this.calendarData.prev_month}});
    },
    today : function() {
      this.$router.push({query: {month : "current"}});
    }
  },
  watch: {
    '$route.query'() {
      this.loadData();
    }
  }
}
</script>

<style scoped>

/*calendar_tab*/
.calendar_tab {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--White, #FFF);
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
}

/*+header*/
.calendar_tab .header {
  display: flex;
  margin-bottom: 14px;
}

.calendar_tab .header .col{

}

.calendar_tab .header .left{
  display: flex;
  justify-content: start;
  align-items: center;
  flex: 1;
  gap: 10px;
}

.calendar_tab .header .left .pagination {
  display: flex;
}

.calendar_tab .header .left .pagination span {
  display: flex;
  padding: 5px;
  cursor: pointer;
}

.calendar_tab .header .left .pagination span.prev {
  border-radius: 8px 0px 0px 8px;
  border: 1px solid var(--Border, #EDEDED);
}

.calendar_tab .header .left .pagination span.next {
  border-radius: 0px 8px 8px 0px;
  border: 1px solid var(--Border, #EDEDED);
}

.calendar_tab .header .left .today {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  background: var(--BG, #F8F8F8);
  padding: 0px 16px;
  cursor: pointer;
  height: 36px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}

.calendar_tab .header .mid{
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.calendar_tab .header .mid .month {
  color: var(--Black, #222);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
}

.calendar_tab .header .right {
  display: flex;
  justify-content: end;
  align-items: center;
  flex: 1;
}

.calendar_tab .header .right .type {
  display: flex;
}

.calendar_tab .header .right .type span {
  color: var(--Gray, #656565);
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  height: 36px;
  box-sizing: border-box;
  padding: 0px 16px;
  border: 1px solid var(--Border, #EDEDED);
  display: flex;
  align-items: center;
  cursor: pointer;
}

.calendar_tab .header .right .type span.active {
  background: var(--Blue, #1B78BC);
  border: 1px solid #1B78BC;
  color: var(--White, #ffffff);
}

.calendar_tab .header .right .type span.m {
  border-radius: 8px 0px 0px 8px;
}

.calendar_tab .header .right .type span.w {
  border: none;
  /*border-top: 1px solid var(--Border, #EDEDED);
  border-bottom: 1px solid var(--Border, #EDEDED);*/
  border: 1px solid var(--Border, #EDEDED);
  border-radius: 0px;
}

.calendar_tab .header .right .type span.d {
  border-radius: 0px 8px 8px 0px;
}
/*-header*/



/*+body*/
.body::-webkit-scrollbar {
  width: 3px; /* Ширина всего элемента навигации */
}

.body::-webkit-scrollbar-track {
  background: #fff; /* Цвет дорожки */
}

.body::-webkit-scrollbar-thumb {
  background: var(--Gray, #656565); /* Цвет бегунка */
  border-radius: 20px; /* Округление бегунка */
  border: 3px solid var(--Border, #EDEDED); /* Оформление границ бегунка */
}

.body {
  border-radius: 8px;
  border: 1px solid var(--Border, #EDEDED);
  display: grid;
  overflow: auto;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: max-content;
}

.body .col {
  border-bottom: 1px solid var(--Border, #EDEDED);
  border-right: 1px solid var(--Border, #EDEDED);
  padding: 10px;
}

.body .col.wd {
  min-height: unset;
}

.body .col.l {
  border-right: none;
}

.body .col.lr {
  border-bottom: none;
}

.body .col.v {
  background: var(--BG, #F8F8F8);
}

.body .col:has(.event_list) {
  min-height: unset;
}

.body .week_days span{
  color: var(--Black, #222);
  text-align: center;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 120%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.body span.day {
  display: flex;
  align-items: center;
  justify-content: end;

  margin-bottom: 10px;

  color: var(--Black, #222);
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 120%;
}

.body span.day.lm {
  opacity: 0.4;
}

.body span.day.c {
  color: var(--Blue);
}

.event_list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.event_list .item {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  cursor: pointer;
}

.event_list .item.success {
  border-radius: 8px;
  border-top: 2px solid #69BE15;
  background: rgba(105, 190, 21, 0.08);
}

.event_list .item.fail {
  border-radius: 8px;
  border-top: 2px solid #EF5350;
  background: rgba(239, 83, 80, 0.08);
}

.event_list .item.attention {
  border-radius: 8px;
  border-top: 2px solid #F58646;
  background: rgba(245, 134, 70, 0.08)
}

.event_list .item .time {
  display: flex;
  align-items: center;
  gap: 6px;
}

.event_list .item .time span{
  color: var(--Black, #222);
  text-align: right;
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 126%;
}

.event_list .item .text {
  color: var(--Black, #222);
  font-family: Inter;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 126%;
  margin: 0px;
}



/*MOBILE*/
@media (max-width: 1250px)
{
  .calendar_tab {
    padding: 18px;
  }

  .calendar_tab .header {
    flex-direction: column;
    gap: 14px;
    margin-bottom: 12px;
  }

  .calendar_tab .header .left {
    justify-content: space-between;
    flex-direction: row-reverse;
  }

  .calendar_tab .header .type {
    display: flex;
    width: 100%;
  }

  .calendar_tab .header .type span {
    flex: 1;
    justify-content: center;
  }

  .body {
    height: auto;
    margin: 0px -18px 0px 0px;
    border-right: unset;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .body .col{
    min-width: 152px;
  }

}

/*-body*/

</style>